
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { DateRange } from '@mui/x-date-pickers-pro'
import AdminPage from 'admin/components/AdminPage'
import { Error } from 'admin/interfaces'
import { getErrors } from 'admin/services/errors/actions'
import PPSelect, { PPSelectOptions } from 'components/PPSelect'
import { sub } from 'date-fns'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Subject } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { message } from 'services/snackbar'
import { StoreThunkDispatch } from 'store/state'
import styles from './ErrorsRoute.pcss'

export function ErrorsRoute() {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const today = new Date()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [range, setRange] = useState<DateRange<Date>>([sub(today, { months: 1 }), today])
  const [datePeriod, setDatePeriod] = useState('1-days')
  const [errors, setErrors] = useState<Error[]>([])
  const [loading, setLoading] = useState(false)
  const [selectedPeriodText, setSelectedPeriodText] = useState('')

  const fetch$ = useRef<Subject<void>>(undefined)

  useEffect(() => {
    fetch$.current = new Subject()
    setLoading(true)
    fetch$.current.pipe(mergeMap(() => dispatch(getErrors(datePeriod))))
      .subscribe((data) => {
        setSelectedPeriodText(`${data.from} to ${data.to}`)
        setErrors(data.errors)
        setLoading(false)
      }, () => {
        dispatch(message('Error fetching posts errors!'))
        setLoading(false)
      })

    fetch$.current.next()

    return () => {
      fetch$.current?.unsubscribe()
    }
  }, [dispatch, datePeriod])

  const confirmCustomRange = () => {
    const start = range[0]?.toISOString()
    const end = range[1]?.toISOString()
    console.log(start, end)

    // props.onValueChange('custom', start, end)
    closeDialog()
  }

  const closeDialog = () => {
    setDialogOpen(false)
  }

  // const dateOptions = [{
  //   value: '1-days',
  //   label: '1 Day'
  // }, {
  //   value: '30-minutes',
  //   label: '30 Minutes'
  // }, {
  //   value: '2-days',
  //   label: '2 Days'
  // }]

  const dateOptions: PPSelectOptions = {
    '1-days': { label: '1 day ago (24 hours)' },
    '30-minutes': { label: 'Last 30 minutes' },
    '3-hours': { label: 'Last 3 hours' },
    '2-days': { label: '2 days ago (24 hours)' },
    '3-days': { label: '3 days ago (24 hours)' },
    '4-days': { label: '4 days ago (24 hours)' },
    '5-days': { label: '5 days ago (24 hours)' }
  }

  const rangeSelected = Boolean(range[0] && range[1])

  const onSelectedDatePeriodChange = (value: string) => {
    setDatePeriod(value)
  }

  return (
    <AdminPage title="Errors">
      <Backdrop open={loading} className={styles.backdrop}>
        <CircularProgress color="primary" />
      </Backdrop>
      <div className={styles.heading}>
        <PPSelect
          options={dateOptions}
          selectedValue={datePeriod}
          onSelectionChange={onSelectedDatePeriodChange}
          className={styles.select}
        />
        <span className={styles.range}>
          {selectedPeriodText}
        </span>
      </div>
      <TableContainer component={Paper} sx={{ marginBottom: '24px' }}>
        <Table sx={{ minWidth: 850 }} aria-label="plans table">
          <TableHead>
            <TableRow className={styles.thead}>
              <TableCell align="center">Total posts count</TableCell>
              <TableCell align="center">Network</TableCell>
              <TableCell align="center">Error</TableCell>
              <TableCell align="center">Affected users</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {errors.map((error) => (
              <ErrorTableRow
                error={error}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </AdminPage>
  )
}

interface ErrorTableRowProps {
  error: Error
}

const ErrorTableRow = ({ error }: ErrorTableRowProps) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        {error.totalCount}
      </TableCell>
      <TableCell align="center">{error.networkType}</TableCell>
      <TableCell align="center">{error.error || 'Successfully published ✅'} </TableCell>
      <TableCell align="center">{error.affectedUsers}</TableCell>
    </TableRow>
  )
}

export default ErrorsRoute
